import { Radio } from "lucide-react";

export function Navbar({ onOpen }: { onOpen: () => void }) {
  return (
    <header className="fixed inset-x-0 top-0 z-40 px-4 pt-4">
      <nav className="glass mx-auto flex max-w-6xl items-center justify-between rounded-2xl px-5 py-3">
        <a href="/" className="flex items-center gap-2">
          <div className="rounded-lg bg-gradient-primary p-1.5 shadow-glow">
            <Radio className="h-4 w-4 text-primary-foreground" />
          </div>
          <span className="text-base font-extrabold tracking-tight">InLiveShop</span>
        </a>
        <div className="hidden items-center gap-7 text-sm text-muted-foreground md:flex">
          <a href="#how" className="transition-colors hover:text-foreground">Como funciona</a>
          <a href="#live" className="transition-colors hover:text-foreground">Ao vivo</a>
          <a href="#sellers" className="transition-colors hover:text-foreground">Para vendedores</a>
          <a href="#rewards" className="transition-colors hover:text-foreground">Recompensas</a>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={onOpen}
            className="rounded-full px-4 py-2 text-sm font-semibold text-foreground/80 transition-colors hover:text-foreground"
          >
            Entrar
          </button>
          <button
            onClick={onOpen}
            className="rounded-full bg-gradient-primary px-4 py-2 text-sm font-bold text-primary-foreground shadow-elegant transition-transform hover:scale-105"
          >
            Cadastrar
          </button>
        </div>
      </nav>
    </header>
  );
}
